import { createAction } from 'deox';
import {
  GET_ORDERS_REQUEST,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILURE,
  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAILURE,
  COMMIT_ORDER_REQUEST,
  COMMIT_ORDER_SUCCESS,
  COMMIT_ORDER_FAILURE,
  GET_ORDER_ITEM_REQUEST,
  GET_ORDER_ITEM_SUCCESS,
  GET_ORDER_ITEM_FAILURE,
  UPDATE_ORDER_ITEM_REQUEST,
  UPDATE_ORDER_ITEM_SUCCESS,
  UPDATE_ORDER_ITEM_FAILURE,
  DELETE_ORDER_ITEM_REQUEST,
  DELETE_ORDER_ITEM_SUCCESS,
  DELETE_ORDER_ITEM_FAILURE,
  OrderDTO,
  OrderItemDTO,
} from './types';

// Получение списка заказов
export const getOrdersAction = {
  request: createAction(GET_ORDERS_REQUEST),
  success: createAction(GET_ORDERS_SUCCESS, resolve => (data: OrderDTO[]) => resolve(data)),
  failure: createAction(GET_ORDERS_FAILURE, resolve => (error: string) => resolve(error)),
};

// Получение одного заказа по ID
export const getOrderByIdAction = {
  request: createAction(GET_ORDER_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(GET_ORDER_SUCCESS, resolve => (data: OrderDTO) => resolve(data)),
  failure: createAction(GET_ORDER_FAILURE, resolve => (error: string) => resolve(error)),
};

// Создание нового заказа
export const createOrderAction = {
  request: createAction(CREATE_ORDER_REQUEST, resolve => (data: OrderDTO) => resolve(data)),
  success: createAction(CREATE_ORDER_SUCCESS, resolve => (data: OrderDTO) => resolve(data)),
  failure: createAction(CREATE_ORDER_FAILURE, resolve => (error: string) => resolve(error)),
};

// Удаление заказа по ID
export const deleteOrderAction = {
  request: createAction(DELETE_ORDER_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(DELETE_ORDER_SUCCESS, resolve => (id: string) => resolve(id)),
  failure: createAction(DELETE_ORDER_FAILURE, resolve => (error: string) => resolve(error)),
};

// Коммит заказа
export const commitOrderAction = {
  request: createAction(COMMIT_ORDER_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(COMMIT_ORDER_SUCCESS, resolve => (data: OrderDTO) => resolve(data)),
  failure: createAction(COMMIT_ORDER_FAILURE, resolve => (error: string) => resolve(error)),
};

// // Добавление товаров в заказ
// export const addItemsAction = {
//   request: createAction(
//     ADD_ITEMS_REQUEST,
//     resolve => (id: string, items: OrderItemDTO[]) => resolve({ id, items }),
//   ),
//   success: createAction(ADD_ITEMS_SUCCESS, resolve => (data: OrderDTO) => resolve(data)),
//   failure: createAction(ADD_ITEMS_FAILURE, resolve => (error: string) => resolve(error)),
// };

// Получение товара из заказа по ID
export const getOrderItemAction = {
  request: createAction(GET_ORDER_ITEM_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(GET_ORDER_ITEM_SUCCESS, resolve => (data: OrderItemDTO) => resolve(data)),
  failure: createAction(GET_ORDER_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};

// Обновление товара в заказе по ID
export const updateOrderItemAction = {
  request: createAction(
    UPDATE_ORDER_ITEM_REQUEST,
    resolve => (id: string, item: OrderItemDTO) => resolve({ id, item }),
  ),
  success: createAction(
    UPDATE_ORDER_ITEM_SUCCESS,
    resolve => (data: OrderItemDTO) => resolve(data),
  ),
  failure: createAction(UPDATE_ORDER_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};

// Удаление товара из заказа по ID
export const deleteOrderItemAction = {
  request: createAction(DELETE_ORDER_ITEM_REQUEST, resolve => (id: string) => resolve(id)),
  success: createAction(DELETE_ORDER_ITEM_SUCCESS, resolve => (id: string) => resolve(id)),
  failure: createAction(DELETE_ORDER_ITEM_FAILURE, resolve => (error: string) => resolve(error)),
};
